import type { AxiosStatic } from "axios"
import axios from "axios"
import * as luxon from "luxon"
import { DateTime, Settings } from "luxon"

// This is the spot to add some high level informational console logs about the app.
// This is _not_ the spot to perform initializations.
export function info(): void {
  const bulbs = "💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡💡"
  console.log("\n")
  console.log(bulbs)
  console.log("💡 Some purely informational logging")
  console.log(bulbs)

  infoDateAndLocale()
  infoAxios()

  console.log(bulbs)
  console.log("💡 Informational logging finished")
  console.log(bulbs)
}

declare global {
  interface Window {
    luxon: typeof luxon
    axios: AxiosStatic
  }
}

function infoAxios() {
  const func = "infoAxios"
  const mAxios = "Axios is available on window.axios for debugging"
  console.log(mAxios, { func })
  window.axios = axios
}

function infoDateAndLocale() {
  const func = "infoDateAndLocale"

  const mLuxon = "🕑 Luxon is available on window.luxon for debugging"
  console.log(mLuxon, { func })
  window.luxon = luxon

  const defaultZone = Settings.defaultZone.name
  console.log("🕑 Luxon default time zone", { func, defaultZone })

  const defaultLocale = Settings.defaultLocale
  console.log(
    `🕑 Luxon default locale, note that it changes when the user, or the i18next framework itself upon initialization, changes languages.`,
    { func, defaultLocale },
  )

  const options = { locale: "is" }
  const isFallbackLocale = DateTime.fromObject({}, options).resolvedLocaleOptions().locale
  console.log(
    [
      `🕑❗ Locale and time zone are independent. Chrome DevTools → More tools → Sensors lets you emulate a different country (changes default time zone).`,
      `🕑❗ Chrome does not support the 'is' locale — it falls back to '${isFallbackLocale}' (derived from navigator.languages: [${navigator.languages.join()}], editable at chrome://settings/languages).`,
    ].join("\n"),
    { func, isFallbackLocale },
  )
}
